import EmptyStateCompany from "components/emptyState";
import TableContract from "components/table/tableContract";
import UseContext from "hooks/useContext";
import { useEffect, useState, useMemo } from "react";
import ApiDatabase from "server";
import Pagination from "components/pagination/pagination";
import { useOutletContext } from "react-router-dom";
import { dateWordShort } from "helper/helper";

const SignedContent = () => {
  const { companyData, refreshTime, language } = UseContext();
  const {
    searchValue = '',
    searchType = 'all',
    perimeterIds,
    isPerimeterColumnShown = false,
    onPerimeterFilterRefused,
  } = useOutletContext() || {};
  // A string key so the effect reruns on a new choice, not on a new array.
  const perimeterFilterKey = (perimeterIds || []).join(',');
  const titles = [
    "N° de contrat",
    "Intérimaire",
    "Mission",
    "N° De mission",
    "ÉTAT",
    ...(isPerimeterColumnShown
      ? [language.getValue("perimeters.listFilter.column")]
      : []),
    "Date",
  ];
  const [arrayContracts, setArrayContracts] = useState([]);
  const [isWaiting, setIsWaiting] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const countPerPage = 25;

  useEffect(() => {
    if (!Object.keys(companyData).length) return undefined;
    // Drops the answer of a request made for a previous filter.
    let cancelled = false;
    const requestedPerimeterIds = perimeterFilterKey ? perimeterFilterKey.split(',') : [];
    setIsWaiting(true);
    ApiDatabase.getContracts(
      { id: companyData._id, perimeterIds: requestedPerimeterIds },
      (data) => {
        if (cancelled) return;
        setArrayContracts(data);
        setIsWaiting(false);
        setCurrentPage(1);
      },
      (err) => {
        if (cancelled) return;
        // A refused filter is cleared, which reloads the list without it.
        if (requestedPerimeterIds.length && onPerimeterFilterRefused?.(err)) return;
        console.log(err);
        setIsWaiting(false);
      }
    );
    return () => {
      cancelled = true;
    };
  }, [companyData._id, refreshTime, perimeterFilterKey, onPerimeterFilterRefused]);

  const hasSignedContract = (item) =>
    item?.contract_company?.some((c) => c.status === "1");

  const filterContracts = (contracts) => {
    const withSigned = contracts.filter(hasSignedContract);
    if (!searchValue) return withSigned;

    const searchLower = searchValue.toLowerCase();

    return withSigned.filter(item => {
      switch (searchType) {
        case 'interimaire':
          return `${item?.userCollection[0]?.firstname || ''} ${item?.userCollection[0]?.lastname || ''}`.toLowerCase().includes(searchLower);
        case 'contrat':
          return item?.contract_company?.some((c) => c.status === "1" && c.id_bestt?.toString().toLowerCase().includes(searchLower));
        case 'mission':
          return (item?.title?.toLowerCase() || '').includes(searchLower) || (item?.id_mission?.toString() || '').includes(searchLower);
        case 'date':
          return item?.contract_company?.some((c) => c.status === "1" && c.createdAt && dateWordShort(c.createdAt).toLowerCase().includes(searchLower));
        case 'all':
        default:
          const allBestt = item?.contract_company?.filter((c) => c.status === "1").map((c) => c.id_bestt || '').join(' ');
          const allSearch = `${allBestt} ${item?.userCollection[0]?.firstname || ''} ${item?.userCollection[0]?.lastname || ''} ${item?.title || ''} ${item?.id_mission || ''}`.toLowerCase();
          return allSearch.includes(searchLower);
      }
    });
  };

  const filteredContracts = useMemo(() => {
    return filterContracts(arrayContracts || []);
  }, [arrayContracts, searchValue, searchType]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchValue, searchType]);

  const countTotal = filteredContracts?.length || 0;
  const totalPages = Math.max(1, Math.ceil(countTotal / countPerPage));
  const paginatedContracts = (filteredContracts || []).slice(
    (currentPage - 1) * countPerPage,
    currentPage * countPerPage
  );

  return (
    <>
      <div>
        {isWaiting ? (
          <TableContract
            champsBody={[]}
            champsHeader={titles}
            isWaiting={true}
            showPerimeter={isPerimeterColumnShown}
          />
        ) : (
          <>
            {filteredContracts.length ? (
              <TableContract champsBody={paginatedContracts} champsHeader={titles} isWaiting={false} showPerimeter={isPerimeterColumnShown} filterStatus="1" />
            ) : (
              <EmptyStateCompany type={"contract"} />
            )}
          </>
        )}
      </div>
      {!isWaiting && filteredContracts.length > 0 && countTotal > countPerPage && (
        <>
        {/* Room for the fixed pagination bar below, so the last row can scroll above it.
            z-30: under the modal overlay (z-40), which used to leave the bar lit above it. */}
        <div className="h-20" aria-hidden="true"/>
        <div className="fixed bottom-0 left-0 right-0 border-t border-gray-100 bg-white px-8 py-4 z-30 tab:left-[80px] sidebar-expanded:left-64">
                  <Pagination
                    currentPage={currentPage}
                    countPerPage={countPerPage}
                    countTotal={countTotal}
                    totalPages={totalPages}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
        </>
              )}
            </>
  );
};

export default SignedContent;
